const capitalizeWord = text => text.replace(/\b\w/g, char => char.toUpperCase());

export default capitalizeWord;
